import React from 'react';

import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors, HStack, sizes, Text, VStack } from '@rtkwlf/fenrir-react';
import { faUserCircle } from '@rtkwlf/pro-solid-svg-icons/faUserCircle';
import type { AttachmentFile } from '@rtkwlf/rendall';

import { DateTime } from 'ae-components/dateTime/DateTime';
import { LogoIcon } from 'ae-components/widgets/Logo';

import { DetailsValue } from '../../ticketDescription/DetailsValue';
import { TicketAttachments } from '../ticketAttachments/TicketAttachments';

export type CommentTileProps = {
  user: string;
  commentTime?: string;
  description: string;
  requesterAgent: boolean;
  attachments?: Array<AttachmentFile>;
};

export const CommentTile: React.FC<CommentTileProps> = ({
  user,
  commentTime,
  description,
  requesterAgent,
  attachments,
}) => (
  <HStack width="full" height="auto">
    <VStack gap="large">
      <HStack paddingTop="small" alignItems="center" flexDirection="row">
        {requesterAgent ? (
          <div
            css={css({
              height: sizes['2rem'],
              width: sizes['2rem'],
            })}
          >
            <LogoIcon width="2rem" height="2rem" />
          </div>
        ) : (
          <FontAwesomeIcon
            icon={faUserCircle}
            css={css({
              color: `rgb(${colors.background.brand.default})`,
              fontSize: '2rem',
            })}
          />
        )}
        <Text styledAs="body2" textColor="neutralTertiary">
          {user}
        </Text>
        <Text textColor="neutralSecondary">
          <DateTime value={commentTime ?? ''} />
        </Text>
      </HStack>
      <VStack>
        <DetailsValue value={description} type="markdown" />
        <TicketAttachments attachments={attachments} />
      </VStack>
    </VStack>
  </HStack>
);
